module.exports = __webpack_public_path__ + "static/media/home-asset-2.72ac7780.png";